export const gridHorizontalPadding = 20;
export const gridVerticlePadding = 20;